<template>
  <section>
    <h6>Dark Mode Feature</h6>
  </section>
</template>

<script>
export default {
  name: 'DarkModeFeature'
}
</script>

<style></style>
